import { Tag } from '../models';
import { ModelResource } from './resource';

export interface CreateTagData {
  name: string;

  color?: string;
}

export class Tags extends ModelResource<Tag, CreateTagData> {
  model = Tag;

  resourcePath = 'v1/tags';
}
